/**
 * GST under reverse charge (RCM).
 *
 * When an invoice is under reverse charge, the GST on it is the company's to
 * pay to the government, not the vendor's to collect. The figure is tracked
 * beside the invoice and deducted from the vendor's payment.
 *
 * Pure, like `tds.ts`: no database, no clock.
 */
/** The GST reversed under RCM: the invoice's GST, or 0 when RCM does not apply. */
export function rcmAmountFor(input) {
    if (!input.rcmApplicable)
        return 0;
    return Math.max(0, input.taxAmount ?? 0);
}
/** Supplier payment after invoice deductions and any advance settlement. */
export function invoiceNetPayableFor(totalAmount, tdsAmount, rcmAmount, advanceAmount = 0) {
    return Math.max(0, totalAmount - tdsAmount - rcmAmount - advanceAmount);
}
//# sourceMappingURL=rcm.js.map